/** Convert an instant to the wall time displayed by datetime-local. */
export function instantToScheduleTime(value: string, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(value));
  const part = (type: string) => parts.find((p) => p.type === type)?.value;
  return `${part('year')}-${part('month')}-${part('day')}T${part('hour')}:${part('minute')}`;
}

/** Reject nonexistent DST times; reject ambiguous repeated wall times rather than shifting silently. */
export function scheduleTimeToInstant(value: string, timeZone: string): string {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) throw new Error('Invalid wall time');
  const wall = Date.parse(`${value}:00Z`);
  const offsets = new Set<number>();
  for (const delta of [-86400000, 0, 86400000]) {
    const instant = wall + delta;
    const local = instantToScheduleTime(new Date(instant).toISOString(), timeZone);
    offsets.add(Date.parse(`${local}:00Z`) - instant);
  }
  const candidates = [...offsets]
    .map((offset) => wall - offset)
    .filter((instant) => instantToScheduleTime(new Date(instant).toISOString(), timeZone) === value)
    .sort((a, b) => a - b);
  if (!candidates.length) throw new Error('Nonexistent wall time');
  if (candidates.length > 1) throw new Error('Ambiguous wall time');
  return new Date(candidates[0]).toISOString();
}
